import request from '@/modules/base/util/request'
import config from '@/config'
import { APIResponse, ResponseBody } from '@/modules/base/util/requestTypes'

const baseUrl = `${config.resourceHost}`

export interface ITenantContactPerson {
  id?: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
}

export interface TenantContactPersonData {
  id: string | null;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  email: string | null;
}

type ContactPersonResponse = ResponseBody<TenantContactPersonData>;

export const TenantContactPersonService = {
  createDefault: (data: ITenantContactPerson): Promise<TenantContactPersonData> => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}tenantContactPerson/default`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data,
      })
        .then((response: APIResponse<ContactPersonResponse>) => {
          resolve(response.body.data)
        })
        .catch(error => reject(error))
    })
  },
  create: (data: ITenantContactPerson): Promise<TenantContactPersonData> => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}tenantContactPerson`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data,
      })
        .then((response: APIResponse<ContactPersonResponse>) => {
          resolve(response.body.data)
        })
        .catch(error => reject(error))
    })
  },
  getDefault: (): Promise<TenantContactPersonData> => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}tenantContactPerson/default`, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then((response: APIResponse<ContactPersonResponse>) => {
          resolve(response.body.data)
        })
        .catch(error => reject(error))
    })
  },
  getAll: (params?: {tenantContactPersonId: string}): Promise<TenantContactPersonData[]> => {
    return new Promise((resolve, reject) => {
      const getAllUrl = `${baseUrl}tenantContactPerson`
      const { tenantContactPersonId } = params || {}
      const query = tenantContactPersonId ? `?tenantContactPersonId=${tenantContactPersonId}` : ''
      const url = getAllUrl + (params ? query : '')

      request(url, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then((response: APIResponse<ResponseBody<TenantContactPersonData[]>>) => {
          resolve(response.body.data)
        })
        .catch(error => reject(error))
    })
  },
  update: (id: string, data: ITenantContactPerson): Promise<TenantContactPersonData> => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}tenantContactPerson/${id}`, {
        method: 'PUT',
        data,
        auth: true,
        isConcurrent: true,
      })
        .then((response: APIResponse<ContactPersonResponse>) => {
          resolve(response.body.data)
        })
        .catch(error => reject(error))
    })
  },
  delete: (id: string): Promise<ContactPersonResponse> => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}tenantContactPerson/${id}`, {
        method: 'DELETE',
        auth: true,
        isConcurrent: true,
      })
        .then((response: ContactPersonResponse) => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
}

export default TenantContactPersonService
